export const utilHelp = {
  fileDownload (filecontent, filename, fileType) {
    var bytes = window.atob(filecontent)
    var ab = new ArrayBuffer(bytes.length)
    var ia = new Uint8Array(ab)
    for (var i = 0; i < bytes.length; i++) {
      ia[i] = bytes.charCodeAt(i)
    }
    var blob = new Blob([ab], { type: (fileType && fileType === 'pdf') ? 'application/pdf' : 'application/ms-excel' })

    if (window.navigator.msSaveBlob) {
      // IE 对a标签下载不支持。微软有自己的下载方法msSaveBlob()。
      try {
        window.navigator.msSaveBlob(blob, filename)
      } catch (e) {
        console.log(e)
      }
    } else {
      var url = URL.createObjectURL(blob)
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.style.display = 'none'
      a.target = '_blank'
      a.href = url
      a.download = filename
      a.target = '_blank'
      a.click()
      document.body.removeChild(a)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/help.js